import { LocaleContext } from '@ui/Locale'
import { useContext } from 'react'

function useLocale() {
  return useContext(LocaleContext)
}

export default useLocale
